/**
 * Impression du recu par window.print() : le poste lance Chrome avec
 * --kiosk-printing (imprimante par defaut, aucune boite de dialogue). Le recu
 * est deja dans la page (RecuImprimable.jsx) ; la feuille d'impression ne
 * garde que lui.
 * @param {Window} [win]
 * @returns {boolean} vrai si l'impression a ete demandee
 */
export function imprimerRecu(win = globalThis.window) {
    if (!win || typeof win.print !== 'function') return false;
    win.print();
    return true;
}
